var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWomensBoots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.918 23.958c-.295-.476-1.331-.697-2.202-.835-1.589-.254-2.386-.978-3.491-1.981l-.062-.055c-1.069-.97-2.318-3.17-2.318-6.184 0-2.017.16-7.313.244-10.158.028-.948.05-1.662.055-1.926-.33-.207-2.09-.687-4.022-.687L11.112 2v.133c-1.991 0-3.75.488-4.112.69.009.174.015.397.026.725.024.763.062 1.996.168 4.34.074 1.637.38 4.508 1.416 8.896l.015.062c.237 1-.403 3.829-.613 4.759L8 21.662c-.129.573-.119 1.36.123 1.684.071.097.156.143.269.146.75.024 4.078.29 5.462 1.06 1.265.704 3.835 1.448 5 1.448 1.295 0 3.863-.625 4.112-1.516.059-.213.044-.38-.047-.526zM8 24c.1 1.068.214 1.771.292 2h2.51c.05-.296.124-.894.198-1.597a20.677 20.677 0 00-2.803-.343c-.07-.004-.131-.04-.197-.06z"
  }))));
}

export default SvgWomensBoots;